<button
    qpxButton="unstyled"
    class="filter-trigger"
    [matMenuTriggerFor]="categoryMenu"
    [attr.aria-label]="`Filter suggestions by category: ${selected()}`"
>
    <qpx-pill
        tone="muted"
        size="sm"
        icon="lucideListFilter"
        [context]="getFilterColorContext(selected())"
        [darkenIconBackground]="selected() !== null && selected() !== 'All'"
        [truncate]="true"
        [class.shadow-xs]="appearance() === 'elevated'"
    >
        <span qpxPillLabel class="max-w-32 truncate">
            {{ selected() === 'All' ? 'Filter' : selected() }}
        </span>
    </qpx-pill>
</button>

<mat-menu #categoryMenu="matMenu" aria-label="Filter suggestions by category">
    @for (category of options(); track category) {
        <button
            mat-menu-item
            class="category-option"
            type="button"
            role="menuitemradio"
            [attr.aria-checked]="selected() === category"
            [style.--filter-background]="getFilterBackground(category)"
            [style.--filter-hover-background]="
                category === 'All'
                    ? 'var(--color-accent)'
                    : getFilterBackground(category)
            "
            [style.--filter-color]="getFilterColor(category)"
            (click)="categorySelected.emit(category)"
        >
            <span class="grow">{{ category }}</span>
            @if (selected() === category) {
                <ng-icon
                    qpx
                    class="order-last ml-3! mr-0!"
                    name="lucideCheck"
                    matMenuItemIcon
                />
            }
        </button>
    }
</mat-menu>
